import script from "./ForgotPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&setup=true&lang=ts"

import "./ForgotPassword.vue?vue&type=style&index=0&id=de720574&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de720574"]])

export default __exports__